module.exports = __webpack_public_path__ + "static/media/autoDoor2.3eaa9c8d.png";